export default __webpack_public_path__ + "static/carlos-14d33dac7074e20e97194e099d31943e.jpg";